/*global _ */
import {parseDateTime, formatDate} from '../../../../../lib/dates'
import RaceCartItemMixin from '../../../../../components/_mixins/race-cart-item'
import {fv} from "../../../../../lib/utils";

export default {
  name: 'packages-cart-item',
  settings: 'page.cart',
  translations: 'page.cart',
  mixins: [RaceCartItemMixin],
  computed: {
    packageRacerDetails() {
      return this.packageRaceInputs.racerDetails || []
    },
    totalParticipants() {
      return this.packageRaceInputs.numberOfAdults
    },
    packageRaceOptions(){
      return _.get(this.item, 'payload.options', {})
    },
    packageRaceInputs(){
      return this.packageRaceOptions['form'] || {}
    },
    packageHeatQuantity(){
      return _.values(this.packageRaceInputs.selectedSlots || {}).length
    },
    packageRaceQuantity(){
      return this.packageRaceOptions.count || 0
    },
    packageItemsPrice(){
      return _.reduce(this.racePointProductItems, (total, item) => {
        return total + (1 * _.get(item, 'payload.options.total'))
      }, 0)
    },
    packageTaxTotal(){
      return _.reduce(this.racePointProductItems, (total, item) => {
        return total + (1 * _.get(item, 'payload.options.tax'))
      }, 0)
    },
    packageItemsTotal(){
      return this.packageItemsPrice + this.packageTaxTotal
    },
    slottedTimes() {
      return _.reduce(this.cartedSlots, (items, slot) => {
        const {time, racers} = slot
        items.push({time, racers})
        return items
      }, [])
    },
    arriveByTime() {
      const slots = _.values(_.mapValues(_.cloneDeep(this.cartedSlots || []), v => {
        const date = parseDateTime(v.datetime)
        if (date) {
          const parsedDate = parseDateTime(date)
          if (parsedDate.isValid) {
            v.day = parsedDate.weekdayLong.toLowerCase()
            v.parsedDate = parsedDate
          }
        }
        return v
      }))
      const product = this.item.attributes.product || {}
      const arriveThresholds = _.mapValues(
        _.mapKeys(
          _.get(product, 'meta.arrival_threshold', []),
          item => (((item || {}).day || '') + '').toLowerCase()
        ),
        'minutes'
      )

      const slot = _.minBy(slots, 'timeAsNumber')
      const day = slot.day
      const date = slot.parsedDate
      const dateKey = formatDate(date, 'yyyy-MM-dd')
      const offset = fv(
        arriveThresholds[dateKey],
        arriveThresholds[day],
        arriveThresholds['all'],
        0
      )
      if (offset) {
        const offsetDate = date.minus({minutes: offset})
        const time = formatDate(offsetDate, 'h:mm a')
        return time
      }
      return null
    }
  }
}
